export function openCustomerService() {
  const globalWindow = window as any;
  // 国外客服
  if ((window as any).$_Tawk) {
    globalWindow.$_Tawk.toggle();
  }
  // 国内客服
  if (globalWindow.qimoChatClick) {
    globalWindow.qimoChatClick();
  }
}
